$(document).ready(function () {

    function validateEmail(email) {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    $('.nuo500').on('click', function () {
        $('.button').removeClass('active');
        $(this).addClass('active');
        $('.section-text .wysiwyg').hide();
        $('.section-text .wysiwyg.nuo500').show();
    });

    $('.nuo1000').on('click', function () {
        $('.button').removeClass('active');
        $(this).addClass('active');
        $('.section-text .wysiwyg').hide();
        $('.section-text .wysiwyg.nuo1000').show();
    });

    $('.reg-form-wrap .submit-wrap .button').on('click', function (e) {
        e.preventDefault();

        var closestForm = $(this).closest('.reg-form-wrap');
        var valElements = closestForm.find('.validatable');

        closestForm.find('.error').hide();
        $('.validatable').parent().removeClass('invalid');

        valElements.each(function (ind, el) {

            if ($(el).attr('name') === 'email') {

                if ($(el).val() === '') {
                    $(el).parent().addClass('invalid');
                    $(el).parent().find('.error.error-required').show();
                } else {
                    $(el).parent().removeClass('invalid');

                    if (!validateEmail($(el).val())) {
                        $(el).parent().addClass('invalid');
                        $(el).parent().find('.error.error-email').show();
                    } else {
                        $(el).removeClass('invalid');
                    }
                }

            } else if ($(el).attr('id') === 'event-checkbox') {

                if (!$(el).is(':checked')) {
                    $(el).closest('.checkbox-wrap').addClass('invalid');
                }

            } else {
                if ($(el).val() === '' || $(el).val() === null) {
                    $(el).parent().addClass('invalid');
                    $(el).parent().find('.error.error-required').show();
                }
            }

        });

        if (!$('.validatable').parent().hasClass('invalid')) {

            var pd = new FormData();
            pd.append('action', 'enduro_requests');

            pd.append('name', $('input[name=name]').val());
            pd.append('team', $('input[name=team]').val());
            pd.append('birthday', $('input[name=birthday]').val());
            pd.append('email', $('input[name=email]').val());
            pd.append('city', $('input[name=city]').val());
            pd.append('country', $('input[name=country]').val());
            pd.append('phone', $('input[name=phone]').val());
            pd.append('weight', $('input[name=weight]').val());
            pd.append('experience', $('input[name=experience]').val());
            pd.append('model', $('input[name=model]').val());
            pd.append('capacity', $('input[name=capacity]').val());
            pd.append('plate', $('input[name=plate]').val());
            pd.append('tour', $('input[name=tour]').val());
            pd.append('type', $('select[name=type]').val());

            pd.append('enduro-nonce', $('input[name=enduro-nonce]').val());
            pd.append('_wp_http_referer', $('input[name=_wp_http_referer]').val());


            $.ajax({
                type: 'POST',
                url: posttarp.ajax_url,
                data: pd,
                dataType: 'json',
                contentType: false,
                processData: false,
                success: function (response) {
                    $('.form-success').addClass('active');
                }
            });
        }

    });

    $('.reg-form-wrap .submit-wrap .button-payment').on('click', function (e) {
        e.preventDefault();

        var closestForm = $(this).closest('.reg-form-wrap');
        var valElements = closestForm.find('.validatable');

        closestForm.find('.error').hide();
        $('.validatable').parent().removeClass('invalid');

        valElements.each(function (ind, el) {

            if ($(el).attr('name') === 'email') {

                if ($(el).val() === '') {
                    $(el).parent().addClass('invalid');
                    $(el).parent().find('.error.error-required').show();
                } else {
                    $(el).parent().removeClass('invalid');

                    if (!validateEmail($(el).val())) {
                        $(el).parent().addClass('invalid');
                        $(el).parent().find('.error.error-email').show();
                    } else {
                        $(el).removeClass('invalid');
                    }
                }

            } else if ($(el).attr('id') === 'event-checkbox') {

                if (!$(el).is(':checked')) {
                    $(el).closest('.checkbox-wrap').addClass('invalid');
                }

            } else if ($(el).attr('id') === 'policy-checkbox') {

                if (!$(el).is(':checked')) {
                    $(el).closest('.checkbox-wrap').addClass('invalid');
                }

            } else {
                if ($(el).val() === '' || $(el).val() === null) {
                    $(el).parent().addClass('invalid');
                    $(el).parent().find('.error.error-required').show();
                }
            }

        });

        if (!$('.validatable').parent().hasClass('invalid')) {
            $('.reg-form-wrap .submit-wrap .button-payment').addClass('invalid');

            var pd = new FormData();
            pd.append('action', 'enduro_requests_payment');

            pd.append('name', $('input[name=name]').val());
            pd.append('team', $('input[name=team]').val());
            pd.append('birthday', $('input[name=birthday]').val());
            pd.append('email', $('input[name=email]').val());
            pd.append('city', $('input[name=city]').val());
            pd.append('country', $('input[name=country]').val());
            pd.append('phone', $('input[name=phone]').val());
            pd.append('weight', $('input[name=weight]').val());
            pd.append('experience', $('input[name=experience]').val());
            pd.append('model', $('input[name=model]').val());
            pd.append('capacity', $('input[name=capacity]').val());
            pd.append('plate', $('input[name=plate]').val());
            pd.append('tour', $('input[name=tour]').val());
            pd.append('type', $('select[name=type]').val());

            pd.append('enduro-nonce', $('input[name=enduro-nonce]').val());
            pd.append('_wp_http_referer', $('input[name=_wp_http_referer]').val());


            $.ajax({
                type: 'POST',
                url: posttarp.ajax_url,
                data: pd,
                dataType: 'json',
                contentType: false,
                processData: false,
                success: function (response) {
                    window.location = response.data;
                }
            });
        } else {
            $('html, body').animate({scrollTop: $('body').find('.input-wrap.invalid').offset().top - 200}, 400);
        }

    });

    $('.reg-form-wrap .submit-wrap .button-payment-kevin').on('click', function (e) {
        e.preventDefault();

        var closestForm = $(this).closest('.reg-form-wrap');
        var valElements = closestForm.find('.validatable');

        closestForm.find('.error').hide();
        $('.validatable').parent().removeClass('invalid');

        valElements.each(function (ind, el) {

            if ($(el).attr('name') === 'email') {

                if ($(el).val() === '') {
                    $(el).parent().addClass('invalid');
                    $(el).parent().find('.error.error-required').show();
                } else {
                    $(el).parent().removeClass('invalid');

                    if (!validateEmail($(el).val())) {
                        $(el).parent().addClass('invalid');
                        $(el).parent().find('.error.error-email').show();
                    } else {
                        $(el).removeClass('invalid');
                    }
                }

            } else if ($(el).attr('id') === 'event-checkbox') {

                if (!$(el).is(':checked')) {
                    $(el).closest('.checkbox-wrap').addClass('invalid');
                }

            } else if ($(el).attr('id') === 'policy-checkbox') {

                if (!$(el).is(':checked')) {
                    $(el).closest('.checkbox-wrap').addClass('invalid');
                }

            } else {
                if ($(el).val() === '' || $(el).val() === null) {
                    $(el).parent().addClass('invalid');
                    $(el).parent().find('.error.error-required').show();
                }
            }

        });

        if (!$('.validatable').parent().hasClass('invalid')) {
            $('.reg-form-wrap .submit-wrap .button-payment-kevin').addClass('invalid');

            var pd = new FormData();
            pd.append('action', 'enduro_requests_payment_kevin');

            pd.append('name', $('input[name=name]').val());
            pd.append('team', $('input[name=team]').val());
            pd.append('birthday', $('input[name=birthday]').val());
            pd.append('email', $('input[name=email]').val());
            pd.append('city', $('input[name=city]').val());
            pd.append('country', $('input[name=country]').val());
            pd.append('phone', $('input[name=phone]').val());
            pd.append('weight', $('input[name=weight]').val());
            pd.append('experience', $('input[name=experience]').val());
            pd.append('model', $('input[name=model]').val());
            pd.append('capacity', $('input[name=capacity]').val());
            pd.append('plate', $('input[name=plate]').val());
            pd.append('tour', $('input[name=tour]').val());
            pd.append('type', $('select[name=type]').val());

            pd.append('enduro-nonce', $('input[name=enduro-nonce]').val());
            pd.append('_wp_http_referer', $('input[name=_wp_http_referer]').val());


            $.ajax({
                type: 'POST',
                url: posttarp.ajax_url,
                data: pd,
                dataType: 'json',
                contentType: false,
                processData: false,
                success: function (response) {
                    window.location = response.data;
                }
            });
        } else {
            $('html, body').animate({scrollTop: $('body').find('.input-wrap.invalid').offset().top - 200}, 400);
        }

    });

    $('.reg-form-wrap .submit-wrap .button-payment-simple').on('click', function (e) {
        e.preventDefault();

        var closestForm = $(this).closest('.reg-form-wrap');
        var valElements = closestForm.find('.validatable');

        closestForm.find('.error').hide();
        $('.validatable').parent().removeClass('invalid');

        valElements.each(function (ind, el) {

            if ($(el).attr('name') === 'email') {

                if ($(el).val() === '') {
                    $(el).parent().addClass('invalid');
                    $(el).parent().find('.error.error-required').show();
                } else {
                    $(el).parent().removeClass('invalid');

                    if (!validateEmail($(el).val())) {
                        $(el).parent().addClass('invalid');
                        $(el).parent().find('.error.error-email').show();
                    } else {
                        $(el).removeClass('invalid');
                    }
                }

            } else if ($(el).attr('id') === 'event-checkbox') {

                if (!$(el).is(':checked')) {
                    $(el).closest('.checkbox-wrap').addClass('invalid');
                }

            } else if ($(el).attr('id') === 'policy-checkbox') {

                if (!$(el).is(':checked')) {
                    $(el).closest('.checkbox-wrap').addClass('invalid');
                }

            } else {
                if ($(el).val() === '' || $(el).val() === null) {
                    $(el).parent().addClass('invalid');
                    $(el).parent().find('.error.error-required').show();
                }
            }

        });

        if (!$('.validatable').parent().hasClass('invalid')) {
            $('.reg-form-wrap .submit-wrap .button-payment-simple').addClass('invalid');

            var pd = new FormData();
            pd.append('action', 'enduro_requests_simple');

            pd.append('name', $('input[name=name]').val());
            pd.append('team', $('input[name=team]').val());
            pd.append('birthday', $('input[name=birthday]').val());
            pd.append('email', $('input[name=email]').val());
            pd.append('city', $('input[name=city]').val());
            pd.append('country', $('input[name=country]').val());
            pd.append('phone', $('input[name=phone]').val());
            pd.append('weight', $('input[name=weight]').val());
            pd.append('experience', $('input[name=experience]').val());
            pd.append('model', $('input[name=model]').val());
            pd.append('capacity', $('input[name=capacity]').val());
            pd.append('plate', $('input[name=plate]').val());
            pd.append('tour', $('input[name=tour]').val());
            pd.append('type', $('select[name=type]').val());

            pd.append('enduro-nonce', $('input[name=enduro-nonce]').val());
            pd.append('_wp_http_referer', $('input[name=_wp_http_referer]').val());


            $.ajax({
                type: 'POST',
                url: posttarp.ajax_url,
                data: pd,
                dataType: 'json',
                contentType: false,
                processData: false,
                success: function (response) {
                    if (response.success) {
                        $('.form-success').addClass('active');
                    }
                }
            });
        } else {
            $('html, body').animate({scrollTop: $('body').find('.input-wrap.invalid').offset().top - 200}, 400);
        }

    });

    $('label[for=event-checkbox]').on('click', function () {
        if ($('#event-checkbox').is(':checked')) {
            $('label[for=event-checkbox]').removeClass('active');
        } else {
            $('label[for=event-checkbox]').addClass('active');
        }
    });

    $('label[for=policy-checkbox]').on('click', function () {
        if ($('#policy-checkbox').is(':checked')) {
            $('label[for=policy-checkbox]').removeClass('active');
        } else {
            $('label[for=policy-checkbox]').addClass('active');
        }
    });

    $('.menu').on('click', function () {
        $(this).toggleClass('active');
        $('.nav').toggleClass('active');
    });

    $('body').on('click', '.reg-table tbody tr, .launch-table tbody tr', function (e) {
        if (!$(e.target).hasClass('ignore-tr')) {
            var _this = $(this);

            var data = {
                action: 'get_edit_form',
                id: $(this).data('id')
            };

            $.post(posttarp.ajax_url, data, function(response) {
                if (response.success) {
                    $('.modal').addClass('active');
                    $('body').addClass('fixed');
                    $('.modal-content').html(response.data.html);
                }
            });
        }
    });

    $('body').on('submit', '.modal form', function (e) {
        e.preventDefault();

        var data = {
            action: 'save_form',
            data: $(this).serialize()
        };

        $.post(posttarp.ajax_url, data, function(response) {
            if (response.success) {
                $('.modal').removeClass('active');
                $('body').removeClass('fixed');
            }
        });
    });

    $('.modal').on('click', function (e) {
        if (e.target === this) {
            $('.modal').removeClass('active');
            $('body').removeClass('fixed');
        }
    });

    $(document).keydown(function(e) {
        if (e.keyCode === 27) {
            $('.modal').removeClass('active');
            $('body').removeClass('fixed');
        }
    });

    $('body').on('click', '.reg-table .arrived-add', function (e) {
        var _this = $(this);

        var data = {
            action: 'arrived_add_action',
            id: $(this).data('id')
        };

        $.post(posttarp.ajax_url, data, function(response) {
            if (response === 'success') {
                _this.parent().html('+');
            }
        });
    });

    $('body').on('click', '.reg-table .agreement-add', function (e) {
        var _this = $(this);

        var data = {
            action: 'agreement_add_action',
            id: $(this).data('id')
        };

        $.post(posttarp.ajax_url, data, function(response) {
            if (response === 'success') {
                _this.parent().html('+');
            }
        });
    });

    $('body').on('click', '.reg-table .agreement-remove', function (e) {
        var _this = $(this);

        var data = {
            action: 'agreement_remove_action',
            id: $(this).data('id')
        };

        $.post(posttarp.ajax_url, data, function(response) {
            if (response === 'success') {
                _this.parent().html('-');
            }
        });
    });

    $('body').on('click', '.launch-table .track-add', function (e) {
        var _this = $(this);

        var data = {
            action: 'track_add_action',
            id: $(this).data('id')
        };

        $.post(posttarp.ajax_url, data, function(response) {
            if (response === 'success') {
                _this.parent().html('+');
            }
        });
    });

    $('body').on('click', '.launch-table .cert-add', function (e) {
        var _this = $(this);

        var data = {
            action: 'cert_add_action',
            id: $(this).data('id')
        };

        $.post(posttarp.ajax_url, data, function(response) {
            if (response === 'success') {
                _this.parent().html('+');
            }
        });
    });

    $('body').on('click', '.launch-table .add-36', function (e) {
        var _this = $(this);

        var data = {
            action: '36_add_action',
            id: $(this).data('id')
        };

        $.post(posttarp.ajax_url, data, function(response) {
            if (response === 'success') {
                _this.parent().html('+');
            }
        });
    });

    $('body').on('click', '.launch-table .time-action', function (e) {
        var _this = $(this);

        var data = {
            action: 'time_action',
            id: $(this).data('id'),
            which: $(this).data('action'),
        };

        $.post(posttarp.ajax_url, data, function(response) {
            if (response.success) {
                _this.parent().html(response.data.html);
            }
        });
    });

});

$(window).on('scroll', function () {

});

$(window).on('resize', function () {

});